import React, {useState} from 'react';
import {Button, Input, Textarea} from "@nextui-org/react";
import Footer from "../Components/Footer";
import {useForm} from "react-hook-form";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function ContactUsPage(props) {
    const {
        register, handleSubmit, reset
    } = useForm();
    const notify = () => toast("You Request has been submitted");

    let [data, setdata] = useState({
        "fname": '',
        "lname": '',
        "email": '',
        "msg": "",
        "mobile": ""
    });
    const onSubmit = (data) => {
        setdata(data);
        console.log(data);
        reset();
        notify();
    }
    return (
        <section className={'relative'} style={{
            height: "85vh",
            width: "100vw",
        }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={'flex flex-col items-center mx-5 md:mx-10 lg:mx-96'}>
                    <div className={'grid gap-5 grid-cols-1 mt-10 w-full md:w-2/3'}>
                        <h1 className={'text-3xl md:text-4xl lg:text-6xl font-bold'}>
                            Contact Us
                        </h1>
                    </div>
                    <div className={'grid gap-5 grid-cols-1 md:grid-cols-2 mt-5 mb-5 w-full md:w-2/3'}>
                        <Input type="text" variant={"bordered"} label="First Name" isRequired
                               {...register("fname", {required: 'First Name is required.'})}
                        />
                        <Input type="text" variant={"bordered"} label="Last Name"
                               {...register("lname")}
                        />
                    </div>
                    <div className={'grid gap-5 grid-cols-1 md:grid-cols-2 mb-5 w-full md:w-2/3'}>
                        <Input type="email" variant={"bordered"} label="Email"

                               {...register("email")} isRequired/>
                        <Input type="number" variant={"bordered"} label="Mobile" {...register("mobile")}/>
                    </div>

                    <div className={'grid gap-5 grid-cols-1 mb-5 w-full md:w-2/3'}>
                        <Textarea type="text" variant={"bordered"} label="Message"

                                  {...register("msg")} isRequired/>
                    </div>

                    <div className={'grid gap-5 grid-cols-1 mt-10 w-3/12 mb-10'}>
                        <Button color={'success'} variant={'ghost'} type={'submit'}>
                            Submit
                        </Button>
                    </div>
                </div>
            </form>
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
            <Footer className={'absolute'}
                    style={{bottom: 0, top: "105%", left: 0, width: "100%"}}/>
        </section>
    );
}

export default ContactUsPage;